import { store } from "@src/index";
import { IOrganization, ITeam } from "@src/types/api";

import { getOrganizations, getTeamsBySite } from "@api";

import { globalActions } from "@features/global/globalSlice";
import { userActions } from "@features/user/userSlice";

import { buildKey, loaderCache } from "@services/loaderCache";

const loader = async () => {
    const orgsKey = buildKey("organizations", "organizations");
    const teamsKey = buildKey("organizations", "teams");

    const cachedOrgs = loaderCache.get<IOrganization[]>(orgsKey);
    const cachedTeams = loaderCache.get<ITeam[]>(teamsKey);

    const promises: Promise<any>[] = [];

    const users = store.getState().user.users;
    const settings = store.getState().global.settings;

    !cachedOrgs && promises.push(getOrganizations());
    !cachedTeams && promises.push(getTeamsBySite(-1));
    !users.length && promises.push(store.dispatch(userActions.getUsers()));
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const results = await Promise.all(promises);
    let resultsIndex = 0;
    let organizations: IOrganization[] | null = cachedOrgs;
    let teams: ITeam[] | null = cachedTeams;

    if (!cachedOrgs) {
        organizations = results[resultsIndex].organizations;
        loaderCache.set(orgsKey, organizations);
        resultsIndex++;
    }

    if (!cachedTeams) {
        teams = results[resultsIndex].teams;
        loaderCache.set(teamsKey, teams);
    }

    return {
        teams,
        organizations,
    };
};

export default loader;
